import { z } from "zod"
import { CHARGING_TYPE_OPTIONS, DEFAULT_CHARGING_TYPE } from "@/src/features/internalUsers/constants"

const ChargingTypeEnum = z.enum(CHARGING_TYPE_OPTIONS.map((o: { value: string }) => o.value) as [string, ...string[]])

const nonNegativeNumericString = (message = "Value must be 0 or greater") =>
    z.string().refine((val) => {
        const num = Number(val)
        return !Number.isNaN(num) && num >= 0
    }, message)

export const CreditsAndVASFormSchema = z.object({
    videoCreditsAvailable: z.number().min(0),
    audioCreditsAvailable: z.number().min(0),
    outboundAudioCreditsAvailable: z.number().min(0),
    addVideoCredits: nonNegativeNumericString(),
    addAudioCredits: nonNegativeNumericString(),
    addOutboundAudioCredits: nonNegativeNumericString(),
    videoPulseRate: nonNegativeNumericString(),
    audioPulseRate: nonNegativeNumericString(),
    outboundAudioPulseRate: nonNegativeNumericString(),
    videoMaxCredits: nonNegativeNumericString(),
    audioMaxCredits: nonNegativeNumericString(),
    attemptFrequency: nonNegativeNumericString(),
    chargingType: ChargingTypeEnum,
    videoEnabled: z.boolean(),
    audioEnabled: z.boolean(),
    outboundAudioEnabled: z.boolean(),
    videoCefrEnabled: z.boolean(),
    videoProctoredMode: z.boolean(),
    audioCefrEnabled: z.boolean(),
    outboundAudioCefrEnabled: z.boolean(),
})

export type CreditsAndVASFormValues = z.infer<typeof CreditsAndVASFormSchema>

export const DEFAULT_CREDITS_AND_VAS_FORM_VALUES: CreditsAndVASFormValues = {
    videoCreditsAvailable: 0,
    audioCreditsAvailable: 0,
    outboundAudioCreditsAvailable: 0,
    addVideoCredits: "0",
    addAudioCredits: "0",
    addOutboundAudioCredits: "0",
    videoPulseRate: "3",
    audioPulseRate: "3",
    outboundAudioPulseRate: "3",
    videoMaxCredits: "100",
    audioMaxCredits: "200",
    attemptFrequency: "3",
    chargingType: DEFAULT_CHARGING_TYPE,
    videoEnabled: true,
    audioEnabled: true,
    outboundAudioEnabled: false,
    videoCefrEnabled: true,
    videoProctoredMode: false,
    audioCefrEnabled: true,
    outboundAudioCefrEnabled: true,
}
